/**
 * 화면별 튜토리얼 대본
 *
 * 규칙
 *  - 개념어부터 던지지 않는다. "무엇을 하려는 상황인지" 를 먼저 말하고 용어를 붙인다.
 *  - 규칙을 설명할 때는 "왜 그런지" 를 한 줄 붙인다.
 *  - 한 스텝은 한 가지만 말한다. 길어지면 스텝을 쪼갠다.
 *
 * target 은 CSS 선택자다. 화면 코드에 data-tour="..." 를 붙여서 가리킨다.
 * 대상을 못 찾으면 말풍선이 화면 가운데에 그냥 뜬다. (스텝이 사라지지는 않는다)
 *
 * 한 주소 안에서 화면이 여러 단계로 바뀌는 경우(마법사 등)에는 화면 쪽에서
 * data-tour-screen="..." 을 바꿔 준다. 대본은 그 값으로 갈라진다.
 */

/** 투어 상품 등록 / 목록 화면 */
const tourProductSteps = [
  {
    target: null,
    eyebrow: '투어 상품 관리',
    title: '여기는 "팔 상품을 만들어 두는 곳" 입니다',
    body: [
      '여행사 업무는 크게 두 덩어리입니다. 팔 것을 만들어 두는 일과, 들어온 예약을 처리하는 일. 이 화면은 앞쪽, 즉 상품을 만들어 두는 쪽입니다.',
      '상품 하나를 팔 수 있게 만들려면 네 단계를 거칩니다. ① 상품 만들기 → ② 기본 설정 → ③ 날짜별 가격·좌석 넣기 → ④ 상세페이지 꾸미기. 이 순서를 따라가면서 버튼을 하나씩 보겠습니다.',
    ],
  },
  {
    target: '[data-tour="new-product"]',
    eyebrow: '① 상품 만들기 → 새 상품 등록',
    title: '항목을 직접 채워서 만드는 정식 등록',
    body: [
      '상품명, 도시, 상품타입, 담당자처럼 나중에 검색·정산에 쓰이는 값을 처음부터 정확히 넣고 시작하는 방식입니다.',
      '누르면 상품이 만들어지고 곧바로 상세 설정 화면으로 넘어갑니다. 여기서 만든 "상품"은 아직 날짜도 가격도 없는 빈 껍데기입니다. 날짜·가격은 다음 단계에서 붙입니다.',
    ],
  },
  {
    target: '[data-tour="smart-product"]',
    eyebrow: '① 상품 만들기 → 스마트 상품 등록',
    title: '급할 때는 최소 정보만 넣고 먼저 만듭니다',
    body: [
      '견적 문의가 들어와서 지금 당장 상품 하나가 필요한 상황을 위한 길입니다. 꼭 있어야 하는 값만 물어보고 나머지는 나중에 채웁니다.',
      '결과물은 [새 상품 등록]으로 만든 것과 똑같은 상품입니다. 빠른 길이지 다른 종류의 상품이 아닙니다.',
    ],
  },
  {
    target: '[data-tour="sale-filter"]',
    eyebrow: '목록 보기 → 판매 여부',
    title: '"판매중"이 기본으로 켜져 있는 이유',
    body: [
      '상품은 한 번 만들면 잘 지우지 않습니다. 작년에 팔던 상품, 잠깐 멈춘 상품이 계속 쌓입니다.',
      '그래서 목록은 기본적으로 지금 팔고 있는 것만 보여 줍니다. 옛날 상품을 찾을 때만 [전체]나 [판매중지]로 바꾸면 됩니다.',
    ],
  },
  {
    target: '[data-tour="event-filter"]',
    eyebrow: '목록 보기 → 행사 여부',
    title: '"행사"는 실제 출발 날짜를 뜻합니다',
    body: [
      '상품은 살아 있어도 출발 날짜가 하나도 안 걸려 있으면 손님은 예약할 수 없습니다. 이런 상품을 "행사 없음" 이라고 부릅니다.',
      '[없음]으로 바꿔 보면 가격·좌석을 아직 안 넣은 상품만 모입니다. 판매 준비가 어디서 멈춰 있는지 확인할 때 씁니다.',
    ],
  },
  {
    target: '[data-tour="product-grid"]',
    eyebrow: '목록 보기 → 상품 목록',
    title: '도시별로 묶여 있고, 행을 펼치면 할 일이 나옵니다',
    body: [
      '목록은 도시로 한 번 묶습니다. 같은 도시 상품끼리 가격·일정이 비슷해서 나란히 놓고 비교하는 일이 많기 때문입니다.',
      '상품 행 왼쪽 화살표를 누르면 아래로 펼쳐지고, 그 안에 [기본설정] [가격/재고] [상세설정] [주문내역] 네 개 버튼이 나옵니다. 이 네 개가 상품 하나를 파는 데 필요한 전부입니다.',
    ],
  },
  {
    target: '[data-tour="product-grid"]',
    eyebrow: '② 기본 설정 · ③ 가격/재고',
    title: '네 개 버튼이 각각 무슨 일을 하나',
    body: [
      '[기본설정] — 상품명, 담당자, 예약을 자동으로 확정할지, 신청금은 얼마 받을지 같은 "이 상품의 판매 규칙"을 정합니다.',
      '[가격/재고] — 달력에 출발일을 찍고 그 날짜의 판매가와 남은 좌석을 넣습니다. 여기를 채워야 비로소 손님이 예약할 수 있습니다.',
      '[상세설정] — 손님에게 보이는 상세페이지(사진, 일정표, 포함/불포함)를 만듭니다. [주문내역] — 그 상품으로 들어온 예약만 모아 봅니다.',
    ],
  },
  {
    target: '[data-tour="product-status"]',
    eyebrow: '점검하기 → 상품등록 현황',
    title: '전체를 한 표로 펼쳐서 빠진 곳을 찾습니다',
    body: [
      '목록이 도시별로 접혀 있으면 전체 그림이 안 보입니다. 이 버튼은 지금 필터에 걸린 상품을 표 하나로 쭉 펼쳐 줍니다.',
      '판매중 몇 개, 중지 몇 개가 위에 숫자로 뜹니다. 시즌 준비가 끝났는지 훑어볼 때 씁니다.',
    ],
  },
  {
    target: null,
    eyebrow: '정리',
    title: '다음에 눌러 볼 곳',
    body: [
      '상품 하나를 펼쳐서 [가격/재고]를 눌러 보세요. 날짜에 가격과 좌석을 넣는 화면이 나옵니다. 여기까지 하면 그 상품은 팔 수 있는 상태가 됩니다.',
      '데모 버전이라 저장을 눌러도 실제로 저장되지는 않습니다. 마음껏 눌러 보셔도 됩니다. 새로고침하면 처음 샘플로 돌아갑니다.',
    ],
  },
];

/** 스마트 상품 등록 — 1단계 (기초 정보) */
const quickWizardBasicSteps = [
  {
    target: null,
    eyebrow: '스마트 상품 등록',
    title: '일정표가 있다면 이 길이 훨씬 빠릅니다',
    body: [
      '[새 상품 등록]은 빈 상품만 만들고 내용은 나중에 채웁니다. [스마트 상품 등록]은 랜드사에서 받은 일정표를 통째로 붙여넣어 내용까지 한 번에 채웁니다.',
      '어느 쪽으로 만들든 결과물은 똑같은 상품입니다. 차이는 "지금 한 번에 어디까지 하느냐" 뿐입니다. 스마트로 만든 상품도 나중에 얼마든지 고칠 수 있습니다.',
    ],
  },
  {
    target: '[data-tour="qw-stepper"]',
    eyebrow: '전체 구조',
    title: '단계는 딱 두 개입니다',
    body: [
      '1단계에서 상품의 뼈대(이름·도시·타입·통화·기간)를 넣고, 2단계에서 일정표를 붙여넣습니다.',
      '끝나면 가격/재고 화면으로 넘어갑니다. 일정과 대표 사진은 그때 이미 채워져 있습니다.',
    ],
  },
  {
    target: '[data-tour="qw-name"]',
    eyebrow: '1단계 → 상품명',
    title: '상품명을 제일 먼저, 그리고 자세히 쓰세요',
    body: [
      '상품명을 쓰고 다른 칸을 누르거나 Enter를 치면, 시스템이 이름을 읽어서 아래 칸들을 알아서 채웁니다.',
      '예를 들어 "[오사카] 유니버셜 스튜디오 2박 3일 자유여행" 이라고 쓰면 도시는 오사카, 기간은 3일, 상품 타입은 자유여행으로 자동으로 들어갑니다.',
      '그래서 상품명을 대충 쓰고 시작하면 오히려 손이 더 갑니다.',
    ],
  },
  {
    target: '[data-tour="qw-city"]',
    eyebrow: '1단계 → 여행 도시',
    title: '도시는 "골라야" 선택된 것입니다',
    body: [
      '검색창에 글자를 치는 것만으로는 아직 고른 게 아닙니다. 아래 목록에서 항목을 눌러야 실제로 선택됩니다.',
      '초성으로도 찾습니다. ㅇㅅㅋ 만 쳐도 오사카가 나오고, 영문 이름으로도 검색됩니다.',
    ],
  },
  {
    target: '[data-tour="qw-type"]',
    eyebrow: '1단계 → 상품 타입',
    title: '패키지냐 자유여행이냐를 정합니다',
    body: [
      '나중에 상품 목록에서 이 값으로 걸러 보게 됩니다. 상품명에 "자유여행", "패키지" 같은 단어가 들어 있으면 여기도 자동으로 채워집니다.',
    ],
  },
  {
    target: '[data-tour="qw-duration"]',
    eyebrow: '1단계 → 소요 시간/기간 · 통화',
    title: '숫자와 단위, 그리고 어떤 돈으로 팔지',
    body: [
      '기간은 숫자를 넣고 옆에서 [일] 또는 [시간]을 고릅니다. 반나절 현지투어라면 시간을, 패키지라면 일을 씁니다.',
      '통화는 이 상품의 금액을 어떤 돈으로 적을지입니다. 나중에 가격을 넣을 때 이 통화 기준으로 들어갑니다.',
    ],
  },
  {
    target: '[data-tour="qw-next"]',
    eyebrow: '1단계 → 다음 단계',
    title: '이 버튼을 누르는 순간 상품이 진짜로 만들어집니다',
    body: [
      '필수 항목(*)을 다 채우기 전에는 눌리지 않습니다.',
      '여기가 중요한 지점입니다. 2단계에서 창을 닫거나 브라우저를 꺼도 상품은 이미 목록에 남아 있습니다. "만들다 말았는데 왜 목록에 있지?" 하는 상황이 여기서 생깁니다.',
      '2단계에서 [이전]으로 돌아와 이름이나 도시를 고쳐도 상품이 새로 또 만들어지지는 않습니다. 고친 내용은 2단계를 마칠 때 함께 저장됩니다.',
    ],
  },
];

/** 스마트 상품 등록 — 2단계 (스마트 등록) */
const quickWizardSmartSteps = [
  {
    target: null,
    eyebrow: '스마트 상품 등록 · 2단계',
    title: '여기가 스마트 등록의 핵심입니다',
    body: [
      '화면이 위아래 두 덩어리입니다. 위는 기본 설정(노출 여부, 키워드, 상품코드, 뱃지), 아래는 일정표를 넣는 곳입니다.',
      '순서는 하나뿐입니다. 붙여넣고 → 전환하고 → 검토에서 다듬고 → 등록. 하나씩 보겠습니다.',
    ],
  },
  {
    target: '[data-tour="qw-basic-settings"]',
    eyebrow: '2단계 → 기본 설정',
    title: '지금 안 채워도 됩니다',
    body: [
      '노출 여부는 손님에게 보일지, 키워드는 검색에 걸릴 단어, 상품코드는 비워 두면 규칙에 따라 자동으로 만들어집니다. 뱃지는 목록에 붙는 짧은 표시(BEST, HOT 같은)입니다.',
      '전부 나중에 상품 목록 → [기본설정]에서 바꿀 수 있습니다. 급하면 건너뛰고 아래 일정부터 넣으세요.',
    ],
  },
  {
    target: '[data-tour="qw-smart-tabs"]',
    eyebrow: '2단계 → 에디터 탭',
    title: '① 일정표를 그대로 붙여넣습니다',
    body: [
      '랜드사가 보내준 일정표를 복사해서(Ctrl+C) 에디터 안에 붙여넣으면(Ctrl+V) 됩니다. 엑셀·한글·워드에서 복사한 표도 모양 그대로 들어갑니다.',
      '옮겨 적거나 다시 타이핑할 필요가 없습니다. 이 붙여넣기 하나를 위해 이 화면이 있습니다.',
    ],
  },
  {
    target: '[data-tour="qw-convert"]',
    eyebrow: '2단계 → 일정표 전환',
    title: '② 붙여넣은 덩어리를 일차별로 쪼갭니다',
    body: [
      '누르면 시스템이 내용을 읽어서 1일차 / 2일차 … 형태로 나눕니다. 끝나면 자동으로 [검토] 탭으로 넘어갑니다.',
      '자동으로 쪼갠 결과라 100% 맞지는 않습니다. 그래서 다음 단계인 검토가 있습니다.',
    ],
  },
  {
    target: '[data-tour="qw-smart-tabs"]',
    eyebrow: '2단계 → 검토 탭',
    title: '③ 검토 탭에서 네 가지를 손봅니다',
    body: [
      '첫째, 필요 없는 항목 지우기 — 일정표에 딸려온 회사 로고나 안내문 같은 건 삭제합니다.',
      '둘째, 구역 정하기 — 각 항목을 상세페이지의 어느 자리에 보여줄지 고릅니다. (투어소개 / 판매정보 / 이용안내 / 취소/환불)',
      '셋째, 일정표 정보 확인 — 각 줄이 일정명인지, 일정내용인지, 호텔인지 고릅니다. 식사와 도시는 자동으로 분류되고, 틀렸으면 바꾸면 됩니다.',
    ],
  },
  {
    target: '[data-tour="qw-smart-itinerary"]',
    eyebrow: '2단계 → 검토 탭 · 가격 항목',
    title: '④ 가격표가 같이 왔다면 여기서 갈라 두세요',
    body: [
      '일정표에 가격표가 섞여 있는 경우가 많습니다. 그 항목의 구역을 [가격/재고]로 지정해 두세요.',
      '그러면 일정 등록이 끝난 뒤 가격/재고 화면에서 버튼 하나로 가격이 일괄 등록됩니다. 안 해두면 날짜별 가격을 하나하나 손으로 넣어야 합니다.',
      '스마트 등록에서 제일 많이 놓치는 곳이 여기입니다.',
    ],
  },
  {
    target: '[data-tour="qw-smart-tabs"]',
    eyebrow: '2단계 → 일정 등록',
    title: '⑤ 마지막 버튼 하나로 세 가지가 처리됩니다',
    body: [
      '검토 탭 오른쪽의 [일정 등록]을 누르면 — 위에 입력한 기본 설정이 저장되고, 선택한 도시의 사진이 최대 10장 갤러리에 자동으로 들어가면서 대표 이미지까지 잡히고, 가격/재고 화면으로 넘어갑니다.',
      '사진은 무작위로 골라집니다. 마음에 안 들면 나중에 상세페이지 설정에서 바꾸면 됩니다.',
    ],
  },
  {
    target: '[data-tour="qw-save-basic"]',
    eyebrow: '2단계 → 기본 설정 저장',
    title: '일정 없이 여기서 멈추고 싶을 때',
    body: [
      '일정표가 아직 없어서 나중에 넣을 생각이라면, 위쪽 기본 설정만 저장하고 나가면 됩니다. 상품은 이미 만들어져 있으니 목록에서 다시 찾을 수 있습니다.',
      '등록이 끝나도 상품은 아직 팔 수 있는 상태가 아닙니다. 가격/재고에 날짜별 판매가와 좌석을 넣어야 손님이 예약할 수 있습니다.',
    ],
  },
];

/** 가격 / 재고 */
const priceStockSteps = [
  {
    target: null,
    eyebrow: '가격 / 재고',
    title: '여기를 채워야 상품이 실제로 팔립니다',
    body: [
      '상품을 만들어도 이 화면을 채우기 전에는 손님이 예약할 수 없습니다. 날짜별 판매가와 남은 자리 수를 넣는 곳입니다.',
      '같은 다낭 상품이라도 10월 15일은 129만원, 12월 24일은 189만원처럼 날짜마다 값이 다릅니다. 하나씩 넣으면 끝이 없으니, 달력에서 기간을 통째로 골라 한 번에 넣습니다.',
      '순서는 늘 같습니다. 고르고 → 끌어서 날짜 선택 → 오른쪽에 입력 → 저장.',
    ],
  },
  {
    target: '[data-tour="product-page-nav"]',
    eyebrow: '맨 위 → 상품 이동 줄',
    title: '같은 상품의 다른 화면으로 건너뛰는 줄',
    body: [
      '[기본설정] [가격/재고] [상세페이지] [주문내역] — 상품 하나를 파는 데 필요한 네 화면입니다. 지금은 가격/재고에 와 있습니다.',
      '위쪽 상품명을 누르면 다른 상품으로 바로 옮겨 갈 수 있습니다. 여러 상품 가격을 연달아 넣을 때 목록으로 되돌아갈 필요가 없습니다.',
    ],
  },
  {
    target: '[data-tour="ps-pattern"]',
    eyebrow: '준비 → 재고구분',
    title: '재고구분은 "자리를 나눠 담는 통"입니다',
    body: [
      '같은 다낭 상품인데 오전 비행기와 저녁 비행기가 따로 있다고 해봅시다. 좌석 수도 따로고 가격도 다릅니다. 이걸 한 상품 안에서 나누려고 만든 게 재고구분입니다.',
      '보통 항공편 단위로 만듭니다. 좌석은 재고구분마다 따로 셉니다.',
    ],
  },
  {
    target: '[data-tour="ps-plan"]',
    eyebrow: '준비 → 요금제',
    title: '요금제는 "그 통에 매기는 가격표"입니다',
    body: [
      '같은 오전 비행기라도 일반 손님에게 파는 값과 제휴사에 주는 값이 다를 수 있습니다. 그래서 한 통(재고구분) 안에 요금제를 여러 개 둡니다. 같은 통의 요금제들은 그 좌석을 나눠 씁니다.',
      '이 화면에서 제일 많이 하는 실수가 여기 있습니다. 위 두 칸을 고르지 않고 값을 넣으면 엉뚱한 조합에 저장되거나 저장이 안 됩니다. 값을 넣기 전에 반드시 확인하세요.',
    ],
  },
  {
    target: '[data-tour="ps-manage"]',
    eyebrow: '준비 → 관리',
    title: '통과 가격표가 아직 없다면 여기서 만듭니다',
    body: [
      '새로 만든 상품이라 선택할 게 아무것도 없다면, 재고구분을 하나 만들고 그 안에 요금제를 만들면 됩니다. 추가·수정·삭제와 순서 바꾸기가 모두 여기 있습니다.',
    ],
  },
  {
    target: '[data-tour="ps-range"]',
    eyebrow: '달력 → 캘린더 노출 기간',
    title: '이건 "보여줄 범위"일 뿐, 저장과 무관합니다',
    body: [
      '시작월·종료월을 넓게 잡으면 여러 달을 한 화면에서 볼 수 있습니다. 그게 전부입니다.',
      '실제로 값이 들어가는 범위는 오른쪽 패널의 [적용기간]입니다. 이 둘을 헷갈려서 엉뚱한 날짜에 저장하는 일이 자주 생깁니다.',
    ],
  },
  {
    target: '[data-tour="ps-calendar"]',
    eyebrow: '달력 → 날짜 고르기',
    title: '마우스로 끌어서 기간을 고릅니다',
    body: [
      '시작일을 누른 채 끝일까지 끌면 그 구간에 색이 들어오고, 고른 범위가 오른쪽 [적용기간]에 그대로 나타납니다.',
      '날짜 칸에서 읽을 수 있는 것 — 숫자는 그 날짜의 판매가, "잔여 N"은 남은 자리 수, "마감"은 더 이상 못 파는 날짜입니다.',
    ],
  },
  {
    target: '[data-tour="ps-panel"]',
    eyebrow: '입력 → 오른쪽 패널',
    title: '고른 날짜에 넣을 값을 여기서 적습니다',
    body: [
      '날짜를 고르면 이 자리가 입력창으로 바뀝니다. 맨 위 [적용기간]이 달력에서 고른 범위와 같은지 먼저 확인하세요.',
      '[적용 요일]로 걸러낼 수 있습니다. 주말만 성수기 요금을 넣고 싶다면 기간은 한 달 전체로 고르고 토·일만 체크하면 됩니다.',
      '[판매가] 탭은 손님에게 받을 돈, [원가] 탭은 우리가 나갈 돈입니다. 총 판매가는 상품가 + Tax·유류할증료로 자동 계산되며 직접 입력하는 칸이 아닙니다.',
    ],
  },
  {
    target: '[data-tour="ps-commission"]',
    eyebrow: '입력 → 판매 커미션',
    title: '대리점에 떼어 줄 몫을 여기서 정합니다',
    body: [
      '우리 상품을 대신 팔아 주는 곳에 주는 몫입니다. 손님이 내는 돈이 아니라, 받은 돈에서 나가는 몫이라는 점이 판매가와 다릅니다.',
      '두 가지 방식 중에 고릅니다. [정률(%)]은 판매가의 몇 퍼센트(예: 7%), [정액]은 건당 얼마(예: 50,000원)입니다. 성인·소아·유아를 따로 정할 수 있습니다.',
      '체크를 켜야 입력칸이 나옵니다. 대리점을 안 쓰는 상품이라면 그냥 꺼 두면 됩니다.',
    ],
  },
  {
    target: '[data-tour="ps-panel"]',
    eyebrow: '입력 → 재고와 마감',
    title: '자리 수를 넣어야 비로소 예약이 됩니다',
    body: [
      '[재고]에 그 날짜에 팔 수 있는 자리 수를 넣습니다. 예약이 들어오면 자동으로 줄고 달력에 "잔여"로 표시됩니다. 재고가 0이면 가격이 있어도 손님은 예약할 수 없습니다.',
      '[마감]에 체크하고 저장하면 자리가 남아 있어도 그 날짜는 막힙니다. 항공이 취소됐거나 출발이 임박했을 때 씁니다.',
      '[저장]을 누르면 고른 날짜 전부에 같은 값이 한 번에 들어갑니다. 이미 값이 있던 날짜는 새 값으로 덮어써집니다.',
    ],
  },
  {
    target: '[data-tour="ps-shared-stock"]',
    eyebrow: '재고 → 공유재고',
    title: '여러 상품이 같은 좌석을 나눠 쓰게 만듭니다',
    body: [
      '항공 좌석 20석을 하나 잡아 두고 패키지 상품과 자유여행 상품이 그 20석을 함께 쓰는 경우가 있습니다. 이럴 때 상품마다 따로 20석을 적어 두면 실제로는 20석인데 40석을 판 꼴이 됩니다.',
      '[공유재고 사용]을 켜면 좌석 묶음(시리즈)을 골라 연결합니다. 연결되면 재고 칸은 잠깁니다 — 자리 수를 이 상품이 정하는 게 아니라 그 묶음이 정하기 때문입니다.',
      '그래서 다른 상품에서 예약이 들어와도 이 상품의 잔여가 같이 줄어듭니다. "잔여 좌석이 이상하게 줄어든다" 싶으면 이 상품이 공유재고를 쓰는지부터 확인하세요. 좌석 묶음 자체는 설정 → 공유재고 관리에서 만듭니다.',
    ],
  },
  {
    target: '[data-tour="ps-virtual-recruit"]',
    eyebrow: '보여주기 → 가상모객',
    title: '실제 예약이 아닌데 몇 명 모인 것처럼 보여 줍니다',
    body: [
      '"이미 몇 명 모였습니다" 가 보이면 손님은 출발이 확정될 것 같다고 느껴 예약을 망설이지 않습니다. 그 느낌을 만들어 주는 표시용 숫자입니다.',
      '[인원]에 몇 명처럼 보일지 넣고, [출발 n일 전]에 언제까지만 보여줄지 넣습니다. 출발이 가까워지면 실제 모객 상황이 드러나므로 그 전에 표시를 거두는 장치입니다.',
      '표시만 바뀔 뿐 실제 좌석은 줄지 않습니다. 잔여석 계산과는 아무 상관이 없습니다.',
    ],
  },
  {
    target: '[data-tour="ps-smart-price"]',
    eyebrow: '지름길 → 스마트 가격 등록',
    title: '가격표가 있다면 하나씩 넣지 마세요',
    body: [
      '랜드사가 보내준 날짜별 가격표를 그대로 붙여넣으면, 시스템이 날짜와 금액을 읽어서 한 번에 등록해 줍니다. 결과를 확인하고 고칠 수도 있습니다.',
      '스마트 상품 등록에서 가격 항목의 구역을 [가격/재고]로 지정해 두었다면, 그 내용이 이미 여기로 넘어와 있습니다. 붙여넣을 필요 없이 확인하고 등록만 하면 됩니다.',
    ],
  },
  {
    target: null,
    eyebrow: '정리',
    title: '안 팔릴 때는 이 세 가지를 순서대로 보세요',
    body: [
      '① 재고가 들어갔는지 (자리 수가 0이면 못 팝니다) ② 마감에 체크되어 있지 않은지 ③ 기본 설정에서 노출로 되어 있는지.',
      '저장했는데 달력에 값이 안 보인다면, 지금 보고 있는 재고구분·요금제 조합이 저장할 때와 다를 가능성이 큽니다. 위쪽 두 칸을 맞춰 보세요.',
      '데모 버전이라 저장을 눌러도 실제로 저장되지는 않습니다. 새로고침하면 처음 샘플로 돌아갑니다.',
    ],
  },
];

/** 상세페이지 설정 */
const detailPageSteps = [
  {
    target: null,
    eyebrow: '상세페이지 설정',
    title: '앞의 두 화면과는 보는 사람이 다릅니다',
    body: [
      '기본 설정과 가격/재고는 우리 직원이 보는 화면이었습니다. 여기는 손님이 보는 화면을 만드는 곳입니다.',
      '여행사 홈페이지에서 상품을 눌렀을 때 나오는 그 페이지입니다. 사진 보고, 일정 보고, 포함사항 보고 예약할지 말지 정하는 바로 그 화면.',
      '왼쪽이 입력, 오른쪽이 손님 화면입니다. 왼쪽에서 고치면 오른쪽에 바로 보입니다. 채울 곳은 네 군데 — 대표이미지 · 미팅장소 · 상품 상세 정보 · 일정표.',
    ],
  },
  {
    target: '#rep-section',
    eyebrow: '① 대표이미지',
    title: '손님이 가장 먼저 보는 사진입니다',
    body: [
      '넣는 방법이 세 가지입니다. [공용 이미지]는 회사에 이미 올려둔 도시별 사진에서 고르는 가장 빠른 길, [상품 갤러리]는 이 상품에 올려둔 사진, [이미지 추가]는 내 컴퓨터에서 직접 올리기입니다.',
      '사진을 끌어서 옮기면 순서가 바뀝니다. 맨 앞 사진(표지)이 상품 목록과 상세페이지 맨 위에 크게 나오니, 가장 잘 나온 사진을 앞으로 보내세요.',
      '순서 변경은 저장 버튼이 없습니다. 바꾸면 자동으로 저장됩니다.',
    ],
  },
  {
    target: '#meeting-section',
    eyebrow: '② 미팅장소',
    title: '손님이 헤매지 않게 구체적으로 적으세요',
    body: [
      '"인천공항"만 적으면 손님은 어디로 가야 할지 모릅니다. "인천공항 3층 A카운터 앞", "다낭공항 도착층 3번 게이트 가이드 팻말"처럼 적어 주세요.',
      '손님이 상세페이지에서 바로 확인하는 정보라, 비워두면 출발 전에 문의 전화가 늘어납니다.',
      '같은 영역에서 [선택옵션]도 관리합니다. 마사지 90분처럼 추가 요금을 받는 옵션 상품입니다. 이름·설명과 함께 1인당인지 1건당인지를 정합니다.',
    ],
  },
  {
    target: '#content-section',
    eyebrow: '③ 상품 상세 정보',
    title: '"구역"은 상세페이지의 서랍입니다',
    body: [
      '포함사항, 불포함사항, 유의사항처럼 글로 된 안내를 넣는 곳입니다. 이 영역은 구역별로 묶여 있습니다.',
      '구역은 그 글을 상세페이지의 어느 자리에 보여줄지 정하는 칸막이입니다. 판매정보 구역에 넣은 글은 판매정보 자리에, 이용안내 구역에 넣은 글은 이용안내 자리에 나옵니다.',
      '항목을 클릭하면 편집 창이 열립니다. 글자 크기·색·표·이미지를 넣을 수 있고, 한글이나 워드에서 복사해 붙여넣어도 서식이 대체로 유지됩니다. 같은 구역 안의 순서는 끌어서 바꾸면 자동 저장됩니다.',
    ],
  },
  {
    target: '[data-tour="dp-smart-itinerary"]',
    eyebrow: '③ 상품 상세 정보 → 지름길',
    title: '일정표가 있다면 여기서 통째로 붙여넣습니다',
    body: [
      '랜드사가 보낸 일정표 전체를 붙여넣어 한 번에 등록합니다. 상품 상세 정보와 일정표를 동시에 채워 줍니다. 쓰는 방법은 스마트 상품 등록의 2단계와 같습니다 — 붙여넣고 → 전환하고 → 검토에서 구역 지정 → 등록.',
      '주의할 점이 하나 있습니다. 일정표에 이미 일정이 있으면 덮어쓰지 않고 기존 일정 아래에 덧붙습니다. "일정이 두 배가 됐다"는 대부분 여기서 생깁니다.',
      '다시 등록하는 경우라면 기존 일정을 먼저 지우고 진행하세요.',
    ],
  },
  {
    target: '#itinerary-section',
    eyebrow: '④ 일정표 편집',
    title: '손님이 가장 꼼꼼히 보는 부분입니다',
    body: [
      '1일차, 2일차… 하루하루를 채웁니다. 하루에 들어가는 것 — 방문지, 일정내용, 일정 이미지, 항공 정보(편명·공항·시간), 식사(조식·중식·석식), 호텔.',
      '일차는 추가·삭제할 수 있고 끌어서 순서도 바꿉니다.',
      '자유일정처럼 비슷한 날이 반복되면 [복사]를 쓰세요. 3일차를 복사해 4일차로 만든 뒤 바뀐 부분만 고치면 처음부터 다시 입력할 필요가 없습니다.',
    ],
  },
  {
    target: '[data-tour="dp-itinerary-type"]',
    eyebrow: '④ 일정표 편집 → 일정타입',
    title: '같은 상품에 일정이 여러 벌 필요할 때',
    body: [
      'A코스와 B코스처럼 같은 상품인데 일정이 갈리는 경우가 있습니다. 여기서 타입을 추가하면 일정표를 여러 벌 만들 수 있습니다. 안 쓰는 타입은 사용중지로 돌려두면 됩니다.',
      '다만 일정타입이 두 개 이상이면 가격/재고 화면에서도 어느 일정타입의 가격인지 골라야 합니다. 관리할 것이 늘어나니 꼭 필요할 때만 늘리세요.',
    ],
  },
  {
    target: '[data-tour="dp-preview"]',
    eyebrow: '⑤ 미리보기',
    title: '오른쪽이 손님이 보는 화면 그대로입니다',
    body: [
      '왼쪽에서 고치고 저장하면 오른쪽에 바로 반영됩니다. 따로 사이트에 들어가 확인할 필요가 없습니다.',
      '"고쳤는데 미리보기에 안 보인다" 싶으면 편집 창에서 [저장]을 눌렀는지부터 확인하세요.',
    ],
  },
  {
    target: '[data-tour="dp-preview-toolbar"]',
    eyebrow: '⑤ 미리보기 → PC · 모바일 · 내보내기',
    title: '모바일 보기를 꼭 확인하세요',
    body: [
      '대부분의 손님은 휴대폰으로 봅니다. 표를 크게 만들거나 글씨를 작게 쓰면 PC에서는 멀쩡해도 모바일에서 깨집니다. [모바일 보기]에서는 기기 종류도 골라서 확인할 수 있습니다.',
      '[이메일로 보내기]는 상세페이지 링크를 손님 메일로 보냅니다. 상담 중에 상품을 보여줄 때 씁니다. 위쪽 [인쇄]는 PDF로 내려받습니다.',
    ],
  },
  {
    target: '[data-tour="dp-resizer"]',
    eyebrow: '⑤ 미리보기 → 넓이 조절',
    title: '가운데 회색 선을 끌면 넓이가 바뀝니다',
    body: [
      '글을 많이 쓸 때는 왼쪽을 넓히고, 결과를 볼 때는 오른쪽을 넓히면 됩니다.',
    ],
  },
  {
    target: null,
    eyebrow: '정리',
    title: '손님에게 내보내기 전 마지막 점검',
    body: [
      '표지 사진이 상품과 맞는가 · 일정표에 빠진 날이 없는가 · 포함사항과 불포함사항이 서로 어긋나지 않는가 · 미팅장소가 적혀 있는가 · 모바일 보기에서 표나 이미지가 깨지지 않는가.',
      '그리고 하나 더. 상세페이지는 보여주는 화면일 뿐입니다. 여기를 아무리 잘 만들어도 가격/재고에 판매가와 자리 수가 들어 있지 않으면 손님은 예약할 수 없습니다.',
      '비슷한 상품을 또 만들 거라면 기본 설정 아래쪽의 [상품 복사]를 쓰세요. 상세페이지 내용까지 통째로 복사됩니다.',
    ],
  },
];

/** 예약 관리 (예약조회 · 주문조회 · 단체조회 …) */
const reservationSteps = [
  {
    target: null,
    eyebrow: '예약 관리',
    title: '여기는 "들어온 예약을 처리하는 곳" 입니다',
    body: [
      '상품 관리가 팔 것을 만들어 두는 쪽이라면, 이 화면은 팔린 다음을 맡습니다. 예약이 들어온 순간부터 손님이 비행기를 타기까지 챙길 일이 여기 다 모여 있습니다.',
      '순서는 늘 같습니다. ① 들어온 예약 확인 → ② 입금 챙기기 → ③ 여권·명단 받기 → ④ 출발 전 확정. 지금 보이는 표가 그 ①번입니다.',
    ],
  },
  {
    target: '[data-tour="settlement-tabs"]',
    eyebrow: '위쪽 탭',
    title: '같은 예약을 다섯 가지 각도로 봅니다',
    body: [
      '탭이 많아 보이지만 밑에 깔린 데이터는 하나입니다. 무엇을 한 줄로 볼지만 다릅니다.',
      '[예약조회] 사람 기준 — 누가 가는가. [주문조회] 주문 기준 — 얼마에 팔렸는가. [단체조회] 출발편 기준 — 이번 출발에 몇 명 모였는가. [상품별 조회] 어느 상품이 잘 팔리는가. [실적 통계] 숫자 요약.',
      '하루 업무는 대부분 [예약조회] 안에서 끝납니다. 나머지는 정산하거나 실적을 볼 때 들릅니다.',
    ],
  },
  {
    target: '[data-tour="reservation-search"]',
    eyebrow: '조회구분 · 조회기간',
    title: '기본이 "행사일 기준 한 달"인 이유',
    body: [
      '행사일은 손님이 실제로 출발하는 날입니다. 오늘 당장 챙겨야 하는 건 곧 떠나는 예약이라, 화면에 들어오면 앞으로 한 달 치 출발 건부터 보여 줍니다.',
      '"이번 달에 얼마나 팔렸지?" 를 보려면 [예약일 기준]으로 바꾸세요. 예약이 접수된 날짜로 다시 셉니다. 같은 예약이라도 두 기준에서 서로 다른 달에 잡힙니다.',
    ],
  },
  {
    target: '[data-tour="reservation-table"]',
    eyebrow: '표 읽는 법',
    title: '한 줄이 예약 한 건이 아니라 "사람 한 명" 입니다',
    body: [
      '네 식구가 한 번에 예약하면 네 줄이 생기고, 왼쪽 칸들이 세로로 합쳐져 한 덩어리로 보입니다. 그 덩어리 하나가 주문 하나입니다.',
      '왜 사람 단위인가 — 항공 발권도, 여권 확인도, 랜드사에 넘기는 명단도 전부 사람 단위로 움직이기 때문입니다. 여권번호가 빈 줄이 곧 "아직 못 받은 사람"입니다.',
    ],
  },
  {
    target: '[data-tour="reservation-table"]',
    eyebrow: '예약정보 칸',
    title: '예약상태와 입금상태는 서로 다른 이야기입니다',
    body: [
      '예약상태는 "이 예약이 살아 있는가"(예약접수 → 예약확정 → 최종확정 → 취소), 입금상태는 "돈이 얼마나 들어왔는가"(미입금 → 부분입금 → 완납)입니다.',
      '둘은 따로 움직입니다. 그래서 확정인데 미입금인 예약이 생기고, 그게 가장 위험합니다. 자리는 잡아 뒀는데 돈은 안 들어온 상태니까요. 이 칸을 눈으로 훑는 이유가 그것입니다.',
    ],
  },
  {
    target: '[data-tour="reservation-table"]',
    eyebrow: '한 번에 처리하기',
    title: '체크해서 여러 건을 한꺼번에 바꿉니다',
    body: [
      '맨 왼쪽 체크칸은 사람이 아니라 주문 단위입니다. 몇 건 고르면 표 위에 파란 띠가 나타나고, 거기서 예약상태를 한 번에 바꿀 수 있습니다.',
      '출발이 확정돼서 그 편에 걸린 예약을 전부 [최종확정]으로 올릴 때처럼, 같은 일을 여러 건에 반복해야 할 때 씁니다.',
    ],
  },
  {
    target: '[data-tour="reservation-new"]',
    eyebrow: '신규예약 추가',
    title: '전화로 받은 예약도 여기서 넣습니다',
    body: [
      '홈페이지로 들어온 예약은 저절로 이 목록에 쌓입니다. 하지만 전화나 메신저로 받은 예약은 누군가 손으로 넣어야 합니다. 그게 이 버튼입니다.',
      '넣고 나면 홈페이지 예약과 똑같이 취급됩니다. 들어온 길만 다를 뿐 같은 예약입니다.',
    ],
  },
  {
    target: '[data-tour="reservation-export"]',
    eyebrow: '엑셀 다운로드',
    title: '지금 보이는 그대로 파일로 떨어집니다',
    body: [
      '랜드사에 명단을 보내거나 항공사에 예약자 목록을 넘길 때 씁니다. 화면에 걸어 둔 조건과 열 구성이 그대로 파일이 됩니다.',
      '그래서 먼저 화면을 원하는 모양으로 만들어 놓고 누르는 게 순서입니다. 옆의 [열 표시/숨김]으로 필요 없는 칸을 빼 두면 파일도 그만큼 깔끔해집니다.',
    ],
  },
  {
    target: null,
    eyebrow: '정리',
    title: '줄을 누르면 예약 한 건의 속으로 들어갑니다',
    body: [
      '아무 줄이나 눌러 보세요. 그 예약의 상세 화면이 열립니다. 입금을 기록하고, 여행객 정보를 채우고, 취소를 처리하는 곳입니다.',
      '데모 버전이라 저장을 눌러도 실제로 저장되지는 않습니다. 마음껏 눌러 보셔도 됩니다. 새로고침하면 처음 샘플로 돌아갑니다.',
    ],
  },
];

/** 예약 상세 — 예약 한 건을 열었을 때 */
const reservationDetailSteps = [
  {
    target: null,
    eyebrow: '예약 상세',
    title: '예약 한 건에 관한 모든 것이 이 한 장에 있습니다',
    body: [
      '위쪽은 누가·언제·무엇을 얼마에 샀는지, 아래쪽은 그래서 지금 무엇이 남았는지입니다.',
      '예약 하나를 여러 사람이 번갈아 만집니다. 상담자가 받고, 수배 담당이 자리를 잡고, 경리가 입금을 확인합니다. 그래서 화면을 나누지 않고 한 장에 몰아 뒀습니다.',
    ],
  },
  {
    target: null,
    eyebrow: '금액',
    title: '더하고 빼는 과정을 그대로 보여 줍니다',
    body: [
      '상품금액 + 택스·유류 − 할인 = 고객결제가. 여기서 대리점 커미션을 빼면 우리 손에 남는 넷가입니다.',
      '입금액과 미수금은 그 아래에 따로 있습니다. 얼마에 팔았는지와 얼마를 받았는지는 다른 이야기라서 섞어 두지 않습니다.',
    ],
  },
  {
    target: null,
    eyebrow: '여행객 명단',
    title: '출발 전까지 계속 채워 나가는 칸입니다',
    body: [
      '예약을 받을 때는 이름과 인원만 알고 시작하는 일이 흔합니다. 여권 사본은 며칠 뒤에 오고, 영문 이름은 그때 확정됩니다.',
      '그래서 이 칸들은 언제든 고칠 수 있게 열려 있습니다. 빈 칸이 남아 있으면 아직 못 받았다는 뜻이고, 그게 출발 전 점검 목록이 됩니다.',
    ],
  },
  {
    target: null,
    eyebrow: '취소',
    title: '취소해도 예약은 지워지지 않습니다',
    body: [
      '취소는 줄을 없애는 게 아니라 상태를 "취소"로 바꾸는 일입니다. 취소료를 얼마 받았는지, 언제 취소됐는지가 남아야 나중에 정산 숫자가 맞기 때문입니다.',
      '데모 버전이라 저장을 눌러도 실제로 저장되지는 않습니다. 새로고침하면 처음 샘플로 돌아갑니다.',
    ],
  },
];

/** 상담 관리 — 견적 문의 목록 화면 */
const consultSteps = [
  {
    target: null,
    eyebrow: '상담 관리',
    title: '여기는 "아직 예약이 아닌 문의"를 담아 두는 곳입니다',
    body: [
      '전화나 메일로 "다낭 4인 가족인데 얼마예요?" 하고 물어보는 일이 하루에도 여러 건 들어옵니다. 이걸 메모지에 적어 두면 며칠 뒤에 누가 어디까지 답했는지 아무도 모릅니다.',
      '그래서 문의가 들어오면 여기에 한 줄로 만들어 둡니다. 이 한 줄을 "상담" 이라고 부릅니다. 상담은 손님이 결정하면 예약이 되고, 접으면 취소로 남습니다.',
    ],
  },
  {
    target: '[data-tour="quote-col-상담상태"]',
    eyebrow: '목록 보기 → 상담상태',
    title: '이 한 칸이 "지금 어디까지 왔나" 를 말해 줍니다',
    body: [
      '상담요청 — 문의만 받아 놓고 아직 아무것도 안 한 상태. 진행중 — 원가를 넣고 견적을 만들고 있는 상태.',
      '예약전환 — 손님이 하겠다고 해서 예약이 된 상태. 상담취소 — 손님이 접은 상태.',
      '아침에 출근해서 [상담요청] 만 걸러 보면 오늘 손대야 할 문의가 그대로 나옵니다. 그게 이 칸을 쓰는 이유입니다.',
    ],
  },
  {
    target: '[data-tour="quote-col-판매업체"]',
    eyebrow: '목록 보기 → 판매업체',
    title: '"이 문의가 어디서 들어왔나" 를 구분합니다',
    body: [
      '직접등록 — 우리가 직접 받은 문의입니다. 대리점 이름 — 그 대리점이 넘겨 준 문의고, 나중에 커미션 정산 대상이 됩니다.',
      '직판 — 어느 대리점도 안 걸린 건입니다. 같은 다낭 4인 견적이라도 대리점 건이면 남는 돈이 달라지기 때문에, 목록 단계에서부터 나눠 둡니다.',
    ],
  },
  {
    target: '[data-tour="quote-period"]',
    eyebrow: '찾기 → 검색기간',
    title: '기간은 "문의가 들어온 날" 기준입니다',
    body: [
      '출발일이 아니라 등록일로 걸립니다. 상담은 "언제 문의가 왔는지" 로 찾는 일이 훨씬 많기 때문입니다. 지난주에 온 문의 중에 답을 안 한 게 있나 — 이런 식으로요.',
      '기본값은 1년 전부터 오늘까지입니다. 날짜를 바꾼 뒤 [적용]을 눌러야 다시 조회합니다.',
    ],
  },
  {
    target: '[data-tour="quote-search"]',
    eyebrow: '찾기 → 견적 검색',
    title: '손님 이름이나 전화번호로도 찾힙니다',
    body: [
      '손님이 다시 전화해서 "지난번에 문의했던 김지현인데요" 하는 상황이 흔합니다. 그때 견적명을 기억할 필요는 없습니다.',
      '견적명 · 인원수 · 담당자 · 요청자명 · 휴대폰 · 등록일 · 출발일을 한꺼번에 훑어서 걸러 줍니다.',
    ],
  },
  {
    target: '[data-tour="quote-new"]',
    eyebrow: '만들기 → 신규 견적 등록',
    title: '문의가 들어오면 먼저 이걸 누릅니다',
    body: [
      '손님 이름, 여행 기간, 인원만 넣어도 상담 한 줄이 만들어집니다. 가격은 아직 몰라도 됩니다.',
      '누르면 상담과 함께 "그 견적용 상품" 하나가 같이 만들어지고 곧바로 상담 상세로 넘어갑니다. 견적을 팔려면 결국 상품이 있어야 하는데, 그걸 따로 만들러 가지 않게 묶어 둔 것입니다.',
    ],
  },
  {
    target: '[data-tour="quote-compare"]',
    eyebrow: '보내기 → 비교견적서',
    title: '여러 안을 한 장에 나란히 놓고 보냅니다',
    body: [
      '같은 손님에게 "4성 안 / 5성 안" 처럼 두세 가지를 제시하는 일이 많습니다. 견적서를 따로 보내면 손님이 비교하기 어렵습니다.',
      '왼쪽 체크박스로 2개에서 4개까지 고르고 누르면, 인원·판매가·총액을 한 표에 붙여 놓은 비교표가 만들어집니다.',
    ],
  },
  {
    target: '[data-tour="quote-table"]',
    eyebrow: '정리',
    title: '아무 줄이나 눌러 보세요',
    body: [
      '그 상담 한 건의 상세 화면이 열립니다. 원가를 넣고 판매가를 정하고 견적서를 만드는 곳입니다.',
      '데모 버전이라 저장을 눌러도 실제로 저장되지는 않습니다. 마음껏 눌러 보셔도 됩니다. 새로고침하면 처음 샘플로 돌아갑니다.',
    ],
  },
];

/** 상담 상세 — 상담 한 건을 열었을 때 */
const consultDetailSteps = [
  {
    target: null,
    eyebrow: '상담 상세',
    title: '문의 한 건을 견적으로 바꾸는 자리입니다',
    body: [
      '하는 일은 네 가지입니다. ① 손님이 말한 조건을 적는다 → ② 원가를 넣는다 → ③ 판매가를 정한다 → ④ 견적서를 만들어 보낸다.',
      '아래쪽에는 이 견적으로 실제로 들어온 예약(주문내역)이 같이 붙어 있습니다. 견적을 보낸 뒤 팔렸는지를 화면을 옮기지 않고 확인하려는 것입니다.',
    ],
  },
  {
    target: '[data-tour="quote-status"]',
    eyebrow: '상태',
    title: '상태는 여기서 바꾸고, 바꾸면 바로 저장됩니다',
    body: [
      '상담요청 → 진행중 → 예약전환 순서로 흘러갑니다. 손님이 접으면 상담취소로 둡니다.',
      '예약전환으로 바꾸면 이 화면이 잠깁니다. 예약이 된 뒤에 견적 금액을 슬쩍 고치면 예약 금액과 어긋나서 정산이 맞지 않기 때문입니다. 그때부터는 예약 관리 화면에서 고칩니다.',
    ],
  },
  {
    target: '[data-tour="quote-customer"]',
    eyebrow: '① 조건 적기 → 고객 정보',
    title: '누가 물어봤고, 어디서 온 문의인지',
    body: [
      '요청자명·휴대폰·이메일은 견적서를 보낼 주소이자 나중에 이 손님을 다시 찾는 열쇠입니다.',
      '판매거래처는 이 문의를 넘겨 준 대리점입니다. 여기에 대리점을 걸어 두면 예약으로 넘어갈 때 커미션 대상이 자동으로 따라갑니다.',
    ],
  },
  {
    target: '[data-tour="quote-trip"]',
    eyebrow: '① 조건 적기 → 여행 일정 & 인원',
    title: '기간과 인원이 곧 견적의 뼈대입니다',
    body: [
      '성인·소아·유아를 나눠서 넣습니다. 나이대마다 항공료와 지상비가 다르기 때문에, 총 인원만으로는 금액이 나오지 않습니다.',
      '여행 기간을 넣으면 그 날짜의 상품 판매가를 끌어와 아래 판매가 칸을 채워 줍니다. 이미 가격을 넣어 둔 상품이라면 손으로 다시 적을 필요가 없습니다.',
    ],
  },
  {
    target: '[data-tour="quote-price"]',
    eyebrow: '② 원가 → ③ 판매가',
    title: '원가를 항목별로 쌓고, 그 위에 남길 돈을 얹습니다',
    body: [
      '항공료 · 유류&TAX · 지상비 · 보험처럼 항목을 나눠 넣습니다. 한 덩어리로 넣어도 계산은 되지만, 나중에 "왜 이 가격이었나" 를 따질 수 없습니다.',
      '원가 합계 바로 옆에 판매가를 넣으면 차액이 예상수익으로 보입니다. 이 숫자를 보면서 깎을지 말지 결정하는 게 견적 업무의 핵심입니다.',
    ],
  },
  {
    target: '[data-tour="quote-notes"]',
    eyebrow: '기록 → 상담내역',
    title: '통화한 내용을 여기에 남깁니다',
    body: [
      '"업그레이드 차액 확인해 준다고 했음", "주말까지 회신 준다고 함" 같은 한 줄이 쌓입니다. 담당자가 휴가를 가도 다른 사람이 이어받을 수 있게 하는 장치입니다.',
      '견적서를 만들 때도 자동으로 한 줄이 남습니다. 언제 무엇을 보냈는지가 기억이 아니라 기록으로 남아야 하기 때문입니다.',
    ],
  },
  {
    target: '[data-tour="quote-preview"]',
    eyebrow: '④ 보내기 → 견적서 생성',
    title: '지금 화면 그대로 견적서가 만들어집니다',
    body: [
      '고객 정보, 여행 기간, 인원, 판매가, 견적 내용이 그대로 한 장에 들어갑니다. 그래서 먼저 위쪽을 채워 놓고 누르는 게 순서입니다.',
      '미리보기에서 PDF로 내리거나 메일로 바로 보낼 수 있습니다.',
    ],
  },
  {
    target: '[data-tour="quote-sync"]',
    eyebrow: '저장',
    title: '"상품 가격/재고에도 저장" 이 켜져 있는 이유',
    body: [
      '상담에 적은 판매가는 견적서에 찍히는 숫자일 뿐입니다. 손님이 실제로 예약을 하려면 그 날짜의 상품에 가격과 좌석이 들어가 있어야 합니다.',
      '이 체크를 켜 두면 저장할 때 연결된 상품의 해당 날짜까지 같이 채워 줍니다. 견적만 만들어 놓고 정작 예약이 안 되는 일을 막는 장치입니다.',
      '데모 버전이라 저장을 눌러도 실제로 저장되지는 않습니다. 새로고침하면 처음 샘플로 돌아갑니다.',
    ],
  },
];

/**
 * 화면별 대본 등록소.
 * match 는 (경로, 화면키) 를 받는다. 화면키는 화면의 data-tour-screen 값이다.
 */
export const TOUR_REGISTRY = [
  {
    key: 'products-tour',
    match: (pathname) => pathname === '/products/tour' || pathname === '/products',
    label: '투어 상품 관리',
    steps: tourProductSteps,
  },
  {
    key: 'quick-wizard-basic',
    match: (pathname, screen) => pathname === '/quick-wizard' && screen !== 'quick-wizard-smart',
    label: '스마트 상품 등록 1단계',
    steps: quickWizardBasicSteps,
  },
  {
    key: 'quick-wizard-smart',
    match: (pathname, screen) => pathname === '/quick-wizard' && screen === 'quick-wizard-smart',
    label: '스마트 상품 등록 2단계',
    steps: quickWizardSmartSteps,
  },
  {
    key: 'price-stock',
    match: (pathname) => pathname.startsWith('/price-stock/'),
    label: '가격 / 재고',
    steps: priceStockSteps,
  },
  {
    key: 'detail-page',
    match: (pathname) => pathname.startsWith('/detail-settings/'),
    label: '상세페이지 설정',
    steps: detailPageSteps,
  },
  {
    // 사이드바 [예약 관리] 는 /settlements 로 간다. /reservations 는 같은 화면의 단독 주소다.
    key: 'reservations',
    match: (pathname) => pathname === '/settlements' || pathname === '/reservations',
    label: '예약 관리',
    steps: reservationSteps,
  },
  {
    key: 'reservation-detail',
    match: (pathname) => pathname.startsWith('/reservation-detail/'),
    label: '예약 상세',
    steps: reservationDetailSteps,
  },
  {
    // /quotes/open(공개 견적 요청) 과 /quotes/compare(비교견적서) 는 별도 화면이라 제외한다.
    key: 'consults',
    match: (pathname) => pathname === '/quotes' || pathname === '/quotes/',
    label: '상담 관리',
    steps: consultSteps,
  },
  {
    key: 'consult-detail',
    match: (pathname) => pathname.startsWith('/quote-detail'),
    label: '상담 상세',
    steps: consultDetailSteps,
  },
];

/** 현재 화면에 맞는 대본을 찾는다. 없으면 null */
export function getTourForPath(pathname, screenKey) {
  const path = String(pathname || '');
  const screen = screenKey ? String(screenKey) : '';
  return TOUR_REGISTRY.find((t) => t.match(path, screen)) || null;
}
